import _Avatar from "@mui/material/Avatar";
import _FormControlLabel from "@mui/material/FormControlLabel";
import _Checkbox from "@mui/material/Checkbox";
import _InputAdornment from "@mui/material/InputAdornment";
import _FormControl from "@mui/material/FormControl";
import _Select from "@mui/material/Select";
import _MenuItem from "@mui/material/MenuItem";
import _InputLabel from "@mui/material/InputLabel";
import _TextField from "@mui/material/TextField";
import _Check from "@mui/icons-material/Check";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import defaultBanner from '../../assets/images/community_default_banner.svg';
import { Autocomplete, FileInput } from '../form';
import { AssociationIcon, CityIcon, CompanyIcon, LinkIcon, PeopleIcon, SchoolIcon } from '../icons';
import CyclabilityZoneForm from './cyclability-zone';
const types = [{
  key: 'private',
  titleKey: 'commons.communities.form.types.private',
  Icon: PeopleIcon
}, {
  key: 'company',
  titleKey: 'commons.communities.form.types.company',
  Icon: CompanyIcon
}, {
  key: 'association',
  titleKey: 'commons.communities.form.types.association',
  Icon: AssociationIcon
}, {
  key: 'school',
  titleKey: 'commons.communities.form.types.school',
  Icon: SchoolIcon
}, {
  key: 'city',
  titleKey: 'commons.communities.form.types.city',
  Icon: CityIcon
}];
export const communityFormSizeRanges = {
  company: [],
  school: [{
    key: 'schoolLessThan50',
    max: 50
  }, {
    key: 'schoolBetween50and100',
    min: 51,
    max: 100
  }, {
    key: 'schoolBetween100and500',
    min: 101,
    max: 500
  }, {
    key: 'schoolMoreThan500',
    min: 501
  }],
  association: [{
    key: 'associationLessThan50',
    max: 50
  }, {
    key: 'associationBetween50and100',
    min: 51,
    max: 100
  }, {
    key: 'associationBetween100and500',
    min: 101,
    max: 500
  }, {
    key: 'associationMoreThan500',
    min: 501
  }],
  city: [{
    key: 'cityLessThan30000',
    max: 29_999
  }, {
    key: 'cityBetween30000and70000',
    min: 30_000,
    max: 69_999
  }, {
    key: 'cityBetween70000and300000',
    min: 70_000,
    max: 299_999
  }, {
    key: 'cityMoreThan300000',
    min: 300_000
  }],
  private: [],
  other: []
};
export function CommunityForm({
  Button,
  isSubmitting,
  disableType,
  eventId,
  allowedParticipantsTypes,
  cyclabilityZone,
  geogroup,
  touched,
  values,
  errors,
  icon,
  bannerPicture,
  handleChange,
  setFieldValue,
  setCyclabilityZone,
  setIcon,
  setBannerPicture
}) {
  const [isAlreadyRegistered, setAlreadyRegistered] = useState();
  const [iconPreviewUrl, setIconPreviewUrl] = useState();
  const [bannerPicturePreviewUrl, setBannerPicturePreviewUrl] = useState();
  const {
    t
  } = useTranslation();
  useEffect(() => {
    if (icon) {
      if (icon instanceof File) setIconPreviewUrl(URL.createObjectURL(icon));else if ('url' in icon) setIconPreviewUrl(icon.url);
    } else {
      setIconPreviewUrl(undefined);
    }
  }, [icon]);
  useEffect(() => {
    if (bannerPicture) {
      if (bannerPicture instanceof File) setBannerPicturePreviewUrl(URL.createObjectURL(bannerPicture));else if ('url' in bannerPicture) setBannerPicturePreviewUrl(bannerPicture.url);
    } else {
      setBannerPicturePreviewUrl(undefined);
    }
  }, [bannerPicture]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !disableType && /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, allowedParticipantsTypes && allowedParticipantsTypes.length === 1 && allowedParticipantsTypes[0] === 'company' ? /*#__PURE__*/React.createElement(_Typography, null, t('commons.communities.form.type_company')) : /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 700,
    variant: "h6"
  }, t('commons.communities.form.type')), /*#__PURE__*/React.createElement(_Typography, null, t('commons.communities.form.type_description'))), /*#__PURE__*/React.createElement(_Box, {
    columnGap: 2,
    display: "flex",
    flexWrap: "wrap",
    rowGap: 1
  }, types.map(({
    key,
    titleKey,
    Icon
  }) => {
    if (key === 'company' && geogroup) return /*#__PURE__*/React.createElement(Fragment, {
      key: key
    });
    if (key === 'city' && !eventId) return /*#__PURE__*/React.createElement(Fragment, {
      key: key
    });
    const active = values.type === key;
    const disabled = isSubmitting || allowedParticipantsTypes && !allowedParticipantsTypes.includes(key);
    return /*#__PURE__*/React.createElement(Button, {
      color: "inherit",
      disabled: disabled,
      endIcon: active && /*#__PURE__*/React.createElement(_Check, {
        sx: {
          color: '#2AC682'
        }
      }),
      key: key,
      onClick: () => setFieldValue('type', key),
      startIcon: /*#__PURE__*/React.createElement(Icon, {
        color: disabled ? 'action' : 'primary'
      }),
      sx: {
        bgcolor: active ? '#ECFBF4' : undefined,
        borderColor: active ? '#2AC682' : '#DDE0E7',
        color: '#212121'
      },
      variant: "outlined"
    }, t(titleKey));
  }))), values.type === 'city' && eventId && /*#__PURE__*/React.createElement(CyclabilityZoneForm, {
    cyclabilityZone: cyclabilityZone,
    eventId: eventId,
    setAlreadyRegistered: setAlreadyRegistered,
    setCyclabilityZone: zone => {
      setCyclabilityZone?.(zone);
      setFieldValue('title', zone?.name || '');
    }
  }), values.type && values.type !== 'company' && (values.type !== 'city' || cyclabilityZone && isAlreadyRegistered !== undefined || geogroup && geogroup.type === 'city') && (isAlreadyRegistered ? /*#__PURE__*/React.createElement(_Typography, {
    color: "error"
  }, t('commons.communities.form.already_registered', {
    title: cyclabilityZone?.name || ''
  })) : /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 700,
    variant: "h6"
  }, t('commons.communities.form.data')), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "flex-start",
    display: "flex",
    gap: 8
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 3
  }, values.type !== 'city' && /*#__PURE__*/React.createElement(_TextField, {
    required: true,
    disabled: isSubmitting,
    error: touched.title && Boolean(errors.title),
    label: t('commons.communities.form.name'),
    margin: "none",
    name: "title",
    onChange: handleChange,
    size: "small",
    slotProps: {
      inputLabel: {
        shrink: true
      }
    },
    value: values.title,
    variant: "outlined"
  }), values.type !== 'private' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_FormControl, {
    required: true,
    disabled: isSubmitting,
    margin: "none",
    size: "small",
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(_InputLabel, {
    htmlFor: "size-range-input"
  }, t('commons.communities.form.size_range')), /*#__PURE__*/React.createElement(_Select, {
    inputProps: {
      id: 'size-range-input'
    },
    label: t('commons.communities.form.size_range'),
    name: "sizeRangeIndex",
    onChange: event => {
      const value = Number(event.target.value);
      setFieldValue('sizeRangeIndex', value);
    },
    size: "small",
    value: values.sizeRangeIndex
  }, communityFormSizeRanges[values.type].map(({
    key,
    min,
    max
  }, index) => /*#__PURE__*/React.createElement(_MenuItem, {
    key: key,
    value: index
  }, t(min !== undefined ? max !== undefined ? 'commons.communities.form.size_ranges.between' : 'commons.communities.form.size_ranges.more_than' : 'commons.communities.form.size_ranges.less_than', {
    context: values.type,
    min,
    max
  }))))), values.type !== 'city' && /*#__PURE__*/React.createElement(Autocomplete, {
    required: true,
    defaultValue: values.address,
    disabled: isSubmitting,
    error: touched.address && Boolean(errors.address),
    inputProps: {
      slotProps: {
        inputLabel: {
          shrink: true
        }
      }
    },
    label: t('commons.communities.form.address') || '',
    onSelect: address => setFieldValue('address', address),
    size: "small"
  })), values.type !== 'city' && /*#__PURE__*/React.createElement(_TextField, {
    fullWidth: true,
    multiline: true,
    disabled: isSubmitting,
    error: touched.description && Boolean(errors.description),
    id: "description",
    label: t('commons.communities.form.description'),
    margin: "none",
    name: "description",
    onChange: handleChange,
    rows: 3,
    slotProps: {
      htmlInput: {
        maxLength: 500
      },
      inputLabel: {
        shrink: true
      }
    },
    value: values.description,
    variant: "outlined"
  }), values.type !== 'city' && /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: {
      xs: 'column',
      lg: 'row'
    },
    gap: 2
  }, /*#__PURE__*/React.createElement(_Box, {
    width: {
      lg: 'calc((100% - 16px) / 2)'
    }
  }, /*#__PURE__*/React.createElement(_TextField, {
    fullWidth: true,
    disabled: isSubmitting,
    error: touched.linkUrl && Boolean(errors.linkUrl),
    label: t('commons.communities.form.link'),
    margin: "none",
    name: "linkUrl",
    onChange: handleChange,
    size: "small",
    slotProps: {
      input: {
        startAdornment: /*#__PURE__*/React.createElement(_InputAdornment, {
          position: "start"
        }, /*#__PURE__*/React.createElement(LinkIcon, {
          color: "primary"
        }))
      },
      inputLabel: {
        shrink: true
      }
    },
    type: "url",
    value: values.linkUrl,
    variant: "outlined"
  })), /*#__PURE__*/React.createElement(_Box, {
    width: {
      lg: 'calc((100% - 16px) / 2)'
    }
  }, /*#__PURE__*/React.createElement(_TextField, {
    fullWidth: true,
    disabled: isSubmitting,
    label: t('commons.communities.form.link_text'),
    margin: "none",
    name: "linkLabel",
    onChange: handleChange,
    size: "small",
    slotProps: {
      inputLabel: {
        shrink: true
      }
    },
    value: values.linkLabel,
    variant: "outlined"
  }))), /*#__PURE__*/React.createElement(_Box, {
    marginTop: -1
  }, /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    sx: {
      marginLeft: 2
    },
    variant: "caption"
  }, t('commons.communities.form.logo')), /*#__PURE__*/React.createElement(FileInput, {
    disablePreview: true,
    disabled: isSubmitting,
    file: icon,
    onChange: setIcon,
    size: "small",
    type: "image"
  }), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    sx: {
      marginLeft: 2
    },
    variant: "caption"
  }, t('commons.communities.form.logo_caption'))), /*#__PURE__*/React.createElement(_Box, {
    marginTop: -1
  }, /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    sx: {
      marginLeft: 2
    },
    variant: "caption"
  }, t('commons.communities.form.banner')), /*#__PURE__*/React.createElement(FileInput, {
    disablePreview: true,
    disabled: isSubmitting,
    file: bannerPicture,
    onChange: setBannerPicture,
    size: "small",
    type: "image"
  }), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    sx: {
      marginLeft: 2
    },
    variant: "caption"
  }, t('commons.communities.form.banner_caption'))), values.type !== 'city' && /*#__PURE__*/React.createElement(_FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_Checkbox, {
      checked: values.automaticChallenge,
      disabled: isSubmitting,
      name: "automaticChallenge",
      onChange: handleChange,
      size: "small"
    }),
    label: t('commons.communities.form.automatic_challenges')
  })), /*#__PURE__*/React.createElement(_Box, {
    border: "1px solid #DDE0E7",
    borderRadius: 4,
    display: {
      xs: 'none',
      md: 'block'
    },
    flexShrink: 0,
    overflow: "hidden",
    width: 360
  }, /*#__PURE__*/React.createElement(_Box, {
    paddingTop: "40%",
    sx: {
      backgroundImage: `url(${bannerPicturePreviewUrl || defaultBanner})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    }
  }), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    marginTop: "-48px",
    padding: 3
  }, /*#__PURE__*/React.createElement(_Avatar, {
    src: iconPreviewUrl,
    sx: ({
      palette
    }) => ({
      bgcolor: palette.primary.main,
      border: '1px solid #CFCFCF',
      height: 96,
      width: 96
    })
  }, !iconPreviewUrl ? values.title ? values.title.substring(0, 2) : /*#__PURE__*/React.createElement(PeopleIcon, {
    fontSize: "large"
  }) : ''), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 600,
    variant: "h6"
  }, values.title || t('commons.communities.form.name')), values.description && /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, values.description), values.linkUrl && /*#__PURE__*/React.createElement(_Typography, {
    color: "primary",
    component: "a",
    href: values.linkUrl,
    target: "_blank",
    variant: "body2"
  }, values.linkLabel || values.linkUrl)), /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#EEF9F4",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    padding: 2
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 700,
    variant: "body2"
  }, t('commons.communities.form.preview_title')), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, t('commons.communities.form.preview_description', {
    geogroupTitle: values.title
  })))))))));
}
export * from './company-form-dialog';